import { useEffect, useRef } from 'react';

export default function usePrevious(value, options) {
    const ref = useRef();
    useEffect(() => {
      if (options?.keepNonNullable && (value === null || value === undefined)) return;
      ref.current = value;
    }, [value, options?.keepNonNullable]);
    return ref.current;
};
